import { render } from "./BaseDropdownDivider.vue?vue&type=template&id=a28746c4"
import script from "./BaseDropdownDivider.vue?vue&type=script&lang=js"
export * from "./BaseDropdownDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__